import { useEffect, useRef, useState } from 'react';
import { Icon } from './JournalOverview';
import './workspace-app-tools.css';

export function loadedAppBundle() {
  const source = [...document.scripts].find(script => /\/static\/js\/main\.[\w-]+\.js(?:\?|$)/.test(script.src))?.src;
  return source ? new URL(source, window.location.href).pathname : '';
}
export async function newerAppBundle(current, signal) {
  if (!current) return false;
  const response = await fetch('/asset-manifest.json', { cache: 'no-store', credentials: 'same-origin', signal });
  if (!response.ok) throw new Error('Update check unavailable.');
  const manifest = await response.json(), value = manifest?.files?.['main.js'];
  if (typeof value !== 'string') throw new Error('Update check unavailable.');
  const next = new URL(value, window.location.origin);
  if (next.origin !== window.location.origin || !/^\/static\/js\/main\.[\w-]+\.js$/.test(next.pathname)) throw new Error('Update check unavailable.');
  return next.pathname !== current;
}
export default function AppUpdateNotice({ blocked = false, onReload = () => window.location.reload() }) {
  const [available, setAvailable] = useState(false), [later, setLater] = useState(false), [message, setMessage] = useState('');
  const latest = useRef(blocked); latest.current = blocked;
  useEffect(() => { if (!blocked) setMessage(''); }, [blocked]);
  useEffect(() => {
    const current = loadedAppBundle(); if (!current) return;
    const controller = new AbortController(); let lastCheck = 0, running = false, active = true;
    const check = async force => {
      if (running || document.hidden || (!force && Date.now() - lastCheck < 60000)) return;
      running = true; lastCheck = Date.now();
      try { const changed = await newerAppBundle(current, controller.signal); if (active && changed) setAvailable(true); }
      catch {} finally { running = false; }
    };
    const returned = () => { if (!document.hidden) { setLater(false); check(false); } };
    const manual = () => { setLater(false); check(true); };
    check(true); const timer = setInterval(() => check(false), 5 * 60000);
    window.addEventListener('focus', returned); document.addEventListener('visibilitychange', returned); window.addEventListener('tradelog-check-update', manual);
    return () => { active = false; controller.abort(); clearInterval(timer); window.removeEventListener('focus', returned); document.removeEventListener('visibilitychange', returned); window.removeEventListener('tradelog-check-update', manual); };
  }, []);
  if (!available || later) return null;
  return <aside className="tl-update-notice" aria-label="TradeLog update available"><Icon name="history" size={18}/><div><strong>A new TradeLog update is ready.</strong><span>{message || (blocked ? 'Save or close your current work before updating.' : 'Your saved journal stays safe. Refresh to use the latest version.')}</span></div><button type="button" onClick={() => { if (latest.current || document.querySelector('[aria-modal="true"]')) { setMessage('Save or close your current work before updating.'); return; } onReload(); }}>Update</button><button type="button" aria-label="Remind me about this update later" onClick={() => setLater(true)}><Icon name="close" size={16}/></button></aside>;
}
